module.exports = __webpack_public_path__ + "static/img/kpicon-eye-on.5ad2a002.svg";